import { SponsoredPlacementsProvider } from '@pata-app/ui-sponsored-placements';

import React from 'react';

import AppWrapper from '../../components/appWrapper/appWrapper';
import useScrollToLocation from '../../hooks/useScrollToLocation';
import { getEnv } from '../../lib/utils/getEnv';
import BusinessAd from './components/businessAd/businessAd';
import { BusinessCategories } from './components/businessCategories/businessCategories';
import HighlightsSection from './components/businessSection/highlightsSection';
import BusinessCarousel from './components/businessesCarousel/businessCarousel';
import BusinessPartner from './components/callToAction/businessPartner';
import HeroSection from './components/heroSection/heroSection';

const { VITE_SPONSORED_PLACEMENT_CONFIG_URL } = getEnv();

const Home = () => {
  useScrollToLocation();

  return (
    <SponsoredPlacementsProvider configUrl={VITE_SPONSORED_PLACEMENT_CONFIG_URL}>
      <AppWrapper>
        <HeroSection />
        <BusinessCarousel />
        <HighlightsSection />
        <BusinessAd />
        <BusinessCategories />
        <BusinessPartner />
      </AppWrapper>
    </SponsoredPlacementsProvider>
  );
};

export default Home;
